// extracted by mini-css-extract-plugin
export var animation_block = "rocksOnTrack-module--animation_block--d3b9f";
export var animation_wrapper = "rocksOnTrack-module--animation_wrapper--3f601";
export var path = "rocksOnTrack-module--path--39724";
export var rocks_fall_right = "rocksOnTrack-module--rocks_fall_right--34877";
export var theMotionPath = "rocksOnTrack-module--theMotionPath--afdde";